// @flow
import React, { Component } from 'react';
import axios from 'axios';

const emailRegex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      company: '',
      location: '',
      message: '',
      emailValid: false,
      nameValid: false,
      messageValid: false,
      formValid: false,
      formSubmitting: false,
      formErrors: {
        email: '',
        name: '',
        message: ''
      },
      errorMessage: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  validateField(fieldName, value) {
    switch (fieldName) {
      case 'email':
        const emailValid = !!value.match(emailRegex);
        this.setState({
          formErrors: {
            ...this.state.formErrors,
            email: emailValid ? '' : ' is not valid'
          },
          emailValid: emailValid,
          formValid:
            emailValid && this.state.nameValid && this.state.messageValid
        });
        break;
      case 'name':
        const nameValid = value.length > 0;
        this.setState({
          formErrors: {
            ...this.state.formErrors,
            name: nameValid ? '' : ' is required'
          },
          nameValid: nameValid,
          formValid:
            nameValid && this.state.emailValid && this.state.messageValid
        });
        break;
      case 'message':
        const messageValid = value.length > 0;

        this.setState({
          formErrors: {
            ...this.state.formErrors,
            message: messageValid ? '' : ' is required'
          },
          messageValid: messageValid,
          formValid:
            messageValid && this.state.emailValid && this.state.nameValid
        });
        break;
    }
  }
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({ [name]: event.target.value }, () => {
      this.validateField(name, value);
    });
  }
  handleSubmit(event) {
    const submitData = {
      form: 'contact-page-request-demo',
      name: this.state.name,
      email: this.state.email,
      company: this.state.company,
      location: this.state.location,
      message: this.state.message
    };

    axios
      .post('https://submit.path.net/contact', submitData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response && response.data && response.data.success) {
          this.setState({
            errorMessage: 'Your message has been received. Thank you.',
            name: '',
            email: '',
            company: '',
            location: '',
            message: '',
            formValid: false,
            formSubmitting: false
          });
        } else {
          this.setState({
            errorMessage:
              'There was an error submitting your message. Please try again shortly.',
            formSubmitting: false
          });
        }
      })
      .catch(error => {
        this.setState({
          errorMessage:
            'There was an error submitting your message. Please try again shortly.',
          formSubmitting: false
        });
      });
    this.setState({ formSubmitting: true });
    event.preventDefault();
  }
  render() {
    const {
      name,
      email,
      company,
      location,
      message,
      formValid,
      formSubmitting
    } = this.state;

    return (
      <div className="contactForm">
        <div className="formErrors">
          {this.state.errorMessage && <p>{this.state.errorMessage}</p>}
          {!formValid &&
            Object.keys(this.state.formErrors).map((fieldName, i) => {
              if (this.state.formErrors[fieldName].length > 0) {
                return (
                  <p className="validationError" key={i}>
                    {fieldName} {this.state.formErrors[fieldName]}
                  </p>
                );
              } else {
                return '';
              }
            })}
        </div>
        <form onSubmit={this.handleSubmit}>
          <label htmlFor="name">Name</label>
          <input
            name="name"
            type="text"
            placeholder="Name"
            value={name}
            onChange={this.handleChange}
          />

          <label htmlFor="email">Email</label>
          <input
            name="email"
            type="text"
            placeholder="Email"
            value={email}
            onChange={this.handleChange}
          />

          <label htmlFor="company">Company</label>
          <input
            name="company"
            type="text"
            placeholder="Company"
            value={company}
            onChange={this.handleChange}
          />

          {/*TODO: Add Mapping API to get address here.*/}
          {/*<label htmlFor="location">Location</label>*/}
          {/*<input*/}
          {/*name="location"*/}
          {/*type="text"*/}
          {/*placeholder="Location"*/}
          {/*value={location}*/}
          {/*onChange={this.handleChange}*/}
          {/*/>*/}

          <label htmlFor="message">Message</label>
          <textarea
            name="message"
            value={message}
            onChange={this.handleChange}
          />

          <input
            disabled={!formValid || formSubmitting}
            type="submit"
            value="Inquire"
          />
        </form>
      </div>
    );
  }
}
export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/generic/contactForm.js